import Vue from "vue";
import VueRouter from "vue-router";

import ownerRoutes from "./owner";
import patientRoutes from "./patient";
import practitionerRoutes from "./practitioner";
import registrarRoutes from "./registrar";
import { ifNotAuthenticated, logOutGuard, roomGuard } from "./utils";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/Landing/View.vue"),
  },
  {
    path: "/brokers",
    component: () => import("../views/Landing/Brokers.vue"),
  },
  {
    path: "/employers",
    component: () => import("../views/Landing/Employers.vue"),
  },
  {
    path: "/patients",
    component: () => import("../views/Landing/Patients.vue"),
  },
  {
    path: "/about",
    component: () => import("../views/Landing/About.vue"),
  },
  {
    path: "/support",
    component: () => import("../views/Landing/Support.vue"),
  },
  {
    path: "/auth",
    component: () => import("../views/Auth/View.vue"),
    children: [
      {
        path: "signin",
        name: "signin",
        beforeEnter: ifNotAuthenticated,
        component: () => import("../views/Auth/SignIn/View.vue"),
      },
      {
        path: "action",
        name: "resetPassword",
        beforeEnter: ifNotAuthenticated,
        component: () => import("../views/Auth/ResetPassword/View.vue"),
      },
      {
        path: "request-reset-password",
        name: "requestResetPassword",
        beforeEnter: ifNotAuthenticated,
        component: () => import("../views/Auth/RequestResetPassword/View.vue"),
      },
      {
        path: "signup",
        name: "signup",
        beforeEnter: logOutGuard,
        component: () => import("../views/Auth/SignUp/View.vue"),
        children: [
          {
            path: ":inviteId",
            name: "patientSignUp",
            component: () => import("../views/Auth/SignUp/Patient/View.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/room/:roomId",
    name: "publicRoomCall",
    beforeEnter: roomGuard,
    component: () => import("../views/Public/Room/View.vue"),
  },
  ...ownerRoutes,
  ...practitionerRoutes,
  ...patientRoutes,
  ...registrarRoutes,
  {
    path: "/uikit",
    component: () => import("../views/UiKit.vue"),
  },
  {
    path: "/consent",
    component: () => import("../views/Terms/Consent.vue"),
  },
  {
    path: "/terms",
    component: () => import("../views/Terms/Terms.vue"),
  },
  {
    path: "/*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
